
import React from "react";
import { useParams } from "react-router-dom";
import { ParentPageHeader, PortalLoading, useParentPortal } from "./parentPortalUtils";

function ParentChildProfilePage() {
  const { studentId } = useParams();
  const { data, loading, reload } = useParentPortal(`parent-portal/children/${studentId}/profile/`);
  if (loading && !data) return <PortalLoading />;

  const student = data?.student || {};
  const classGroup = student.class_group || {};

  return (
    <div className="container-fluid py-4">
      <ParentPageHeader title="Child Profile" subtitle={student.full_name || "Student information"} icon="bi-person-vcard" actions={<button className="btn btn-light border" onClick={reload}>Refresh</button>} />
      <div className="card border-0 shadow-sm"><div className="card-body">
        <div className="row g-3">
          <Info label="Full Name" value={student.full_name} />
          <Info label="Admission No." value={student.admission_number} />
          <Info label="Class Group" value={classGroup.name} />
          <Info label="Class Teacher" value={classGroup.class_teacher} />
          <Info label="Email" value={student.email} />
          <Info label="Phone" value={student.phone} />
          <Info label="Gender" value={student.gender} />
          <Info label="Date of Birth" value={student.date_of_birth} />
          <Info label="Enrollment Date" value={student.enrollment_date} />
          <Info label="Emergency Contact" value={student.emergency_contact_name} />
          <Info label="Emergency Phone" value={student.emergency_contact_phone} />
          <Info label="Previous School" value={student.previous_school} />
          <div className="col-12"><InfoBox label="Medical Conditions" value={student.medical_conditions} /></div>
          <div className="col-12"><InfoBox label="Allergies" value={student.allergies} /></div>
        </div>
      </div></div>
    </div>
  );
}

function Info({ label, value }) { return <div className="col-md-4"><InfoBox label={label} value={value} /></div>; }
function InfoBox({ label, value }) { return <div className="border rounded-3 p-3 bg-light h-100"><small className="text-muted text-uppercase fw-bold">{label}</small><div className="fw-semibold mt-1">{value || "-"}</div></div>; }

export default ParentChildProfilePage;
